import { Alert, Stack } from '@mui/material';
import { t } from 'i18next';
import { FormEventHandler, useEffect, useState } from 'react';
import { Dialog, DialogBody } from '../../common/components/Modal/Modal';
import { getErrorMessage } from '../../common/errors/errors';
import { Interpolation } from '../../config/i18n/components/Interpolation';
import { ProjectExceptionRepository } from '../../project-exceptions/services/ProjectExceptionRepository';
import { ButtonBox, DangerButton, TertiaryButton } from '../components/Buttons';

type Props = {
  exceptionId: number;
  onClosed: (exceptionId: number | undefined) => void;
};

export const DeleteExceptionFlow = ({ exceptionId, onClosed }: Props) => {
  const [exceptionRepository] = useState(new ProjectExceptionRepository());
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    return () => {
      exceptionRepository.cancelAllRequests();
    };
  }, [exceptionRepository]);

  const onSubmit: FormEventHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      await exceptionRepository.deleteException(exceptionId);
      setLoading(false);
      onClosed(exceptionId);
    } catch (e: unknown) {
      setError(getErrorMessage(e));
      setLoading(false);
    }
  };

  return (
    <Dialog title={t('deleteException.title')} onDismiss={() => onClosed(undefined)}>
      <DialogBody>
        <Stack spacing={1.5} component="form" onSubmit={onSubmit}>
          {error && <Alert severity="error">{error}</Alert>}
          <Interpolation i18nKey="deleteException.content" items={[{ name: 'color_gray', color: 'grey.700' }]} />
          <ButtonBox>
            <TertiaryButton onClick={() => onClosed(undefined)} disabled={loading}>
              {t('deleteException.back')}
            </TertiaryButton>
            <DangerButton type="submit" autoFocus disabled={loading}>
              {t('deleteException.submit')}
            </DangerButton>
          </ButtonBox>
        </Stack>
      </DialogBody>
    </Dialog>
  );
};
